
<h2 class="title">#{{ call.number }}</h2>
<div 
  fxLayout.lt-md="column" 
  fxLayout="row" 
  fxLayoutGap="20px" 
  class="call-complete"
>
  <div fxFill.lt-md fxFlex="70">
    <app-call-main
      [user]="call.business_user"
      [description]="call.description"
      [userAgent]="call.user_agent"
      [createdAt]="call.added_at"
      [media]="call.media"
    ></app-call-main>

    <app-call-details
      [call]="call.identifier"
      [type]="call.type"
      [priority]="call.priority"
      [status]="call.status"
      [operator]="call.user_id"
    ></app-call-details>

    <app-call-entry
      *ngFor="let item of call.items"
      [item]="item"
      [operator]="true"
    ></app-call-entry>

    <app-call-new-entry
      [call]="call"
      origin="A"
      [operator]="true"
      (newEntry)="newEntry($event)"
      (newFiles)="newFiles($event)"
    ></app-call-new-entry>
  </div>

  <div fxFill.lt-md fxFlex="30">
    <app-call-business
      [business]="call.business"
      (businessChanged)="setBusiness($event)"
    ></app-call-business>

    <app-call-business-user
      [user]="call.business_user"
    ></app-call-business-user>

    <app-call-attachments
      [files]="call.files"
    ></app-call-attachments>

    <app-call-note
      [items]="call.notes"
    ></app-call-note>

    <app-call-status
      [items]="call.statuses"
    ></app-call-status>

    <app-call-tag
      [items]="call.tags"
    ></app-call-tag>
  </div>
</div>
